// First create a new Redux slice (caseSlice.js)
import { createSlice } from '@reduxjs/toolkit';

const caseSlice = createSlice({
  name: 'case',
  initialState: {
    selectedCaseId: localStorage.getItem('selectedCaseId') || ''
  },
  reducers: {
    setSelectedCase: (state, action) => {
      state.selectedCaseId = action.payload;
      localStorage.setItem('selectedCaseId', action.payload);
    }
  }
});

export const { setSelectedCase } = caseSlice.actions;
export default caseSlice.reducer;